var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_5607)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.387207,
    y: 0.927551,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6075 17.9797C13.7291 18.5388 13.9154 18.9008 14.1329 19.1263C14.6501 22.7268 17.8819 25.7952 20.4776 25.6669C23.7796 25.5048 26.1201 21.9462 26.6454 19.1263C26.8628 18.9021 27.0722 18.4227 27.1978 17.8595C27.3382 17.2126 27.4895 16.2375 27.1005 15.7216C27.0776 15.6946 26.929 15.5582 26.9034 15.5353C27.2748 14.1956 28.0905 11.8051 26.0593 9.65648C24.9586 8.49233 23.4298 7.90756 22.0482 7.44568C17.9697 6.08301 15.0904 7.99399 13.7615 11.1718C13.6656 11.3973 13.0457 12.8248 13.7966 15.5353C13.7237 15.5839 13.6575 15.646 13.6021 15.7216C13.2118 16.2362 13.4657 17.3328 13.6075 17.9797Z",
    fill: "#7C93BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7012 37.781C34.5877 35.3028 34.4473 31.3755 32.2824 28.1626C32.2824 28.1626 31.6652 27.3212 30.2012 26.7621C30.2012 26.7621 27.0221 25.7938 25.5582 24.7472L24.8897 25.205L24.9639 29.551L20.9502 40.266C20.8624 40.5009 20.6382 40.6563 20.3884 40.6563C20.1385 40.6563 19.9144 40.5009 19.8266 40.266L15.8142 29.551C15.8142 29.551 15.8885 25.2185 15.8871 25.205C15.8966 25.2415 15.2173 24.7472 15.2173 24.7472C13.756 25.7938 10.5755 26.7621 10.5755 26.7621C9.11157 27.3212 8.49438 28.1626 8.49438 28.1626C6.33085 31.3755 6.1877 35.3028 6.07426 37.781C5.99593 39.4935 6.35516 40.1323 6.80624 40.3146C12.4055 42.5618 28.3672 42.5618 33.9678 40.3146C34.4216 40.1336 34.7781 39.4935 34.7012 37.781Z",
    fill: "#7C93BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5313 27.0512L20.3504 27.0552C19.7669 27.0552 19.1781 26.9418 18.6001 26.7419L20.191 29.1769L18.7635 30.5544L20.2329 39.4773C20.245 39.5542 20.3112 39.6096 20.3895 39.6096C20.4665 39.6096 20.5327 39.5542 20.5462 39.4773L22.0156 30.5544L20.5867 29.1769L22.1547 26.7783C21.6428 26.9283 21.1013 27.0282 20.5313 27.0512Z",
    fill: "#7C93BC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.38721,
    y: 1.92755,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#7C93BC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_5607"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.387207,
    y: 0.927551,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.f31d58534d79a03e9549b3f0aba986e6.svg";
export { ForwardRef as ReactComponent };